@if (title) {
	<h5 class="file-sub-title">
		{{ title }}
	</h5>
}

<div class="related-file-wrapper file-list-wrapper">
	@for (fileData of filesData; track fileData; let index = $index) {
		<file-card
			[file]="fileData"
			[allowDelete]="allowDelete"
			[fileSelected]="selection.isSelected(fileData)"
			(openFile)="openFile.emit(index)"
			(selectionChange)="selection.toggle($event)"
			(deletePressed)="deleteFile.emit(index)"
		/>
	}
</div>
